import { type RouteObject } from 'react-router-dom'
import generalRoutes from './clusters/general/routes'
import masterDataRoutes from './clusters/master-data/routes'

const wmsRoutes: RouteObject[] = [...generalRoutes, ...masterDataRoutes]

export default wmsRoutes
